import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PriceConfig } from './components/PriceConfig';
import { PaymentPage } from './components/PaymentPage';
import { AdminPanel } from './components/AdminPanel';
import { ExternalScheduleView } from './components/ExternalScheduleView';
import { PriceProvider } from './contexts/PriceContext';
import { EmailProvider } from './contexts/EmailContext';
function ProtectedSchedule() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'LetUSATIn') {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };
  if (isAuthenticated) {
    return <ExternalScheduleView data-id="element-55" />;
  }
  return <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4" data-id="element-56">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-8" data-id="element-57">
        <h2 className="text-2xl font-bold text-slate-800 mb-6 text-center" data-id="element-58">
          Schedule Access
        </h2>
        <p className="text-slate-600 mb-6 text-center" data-id="element-59">
          Please enter the password to view the event schedule
        </p>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-60">
          <div data-id="element-61">
            <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-62">
              Password
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter password" autoFocus data-id="element-63" />
          </div>
          {error && <div className="text-red-600 text-sm text-center" data-id="element-64">{error}</div>}
          <button type="submit" className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-65">
            Access Schedule
          </button>
        </form>
      </div>
    </div>;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-66">
      <PriceProvider data-id="element-67">
        <EmailProvider data-id="element-68">
          <Routes data-id="element-69">
            <Route path="/" element={<App data-id="element-71" />} data-id="element-70" />
            <Route path="/config" element={<PriceConfig data-id="element-73" />} data-id="element-72" />
            <Route path="/admin" element={<AdminPanel data-id="element-75" />} data-id="element-74" />
            <Route path="/pay/:invoiceId" element={<PaymentPage data-id="element-77" />} data-id="element-76" />
            <Route path="/schedule" element={<ProtectedSchedule data-id="element-79" />} data-id="element-78" />
          </Routes>
        </EmailProvider>
      </PriceProvider>
    </BrowserRouter>;
}